<template>
    <div class="locator__top-bar-promotions">
        <promo-btn
                v-for="promotion in promotions"
                v-if="promotion.visible_on_places_list && !promotion.visible_menu && !promotion.hide_filter"
                :key="promotion.id"
                :promotionData="promotion"
                :isDropdown="false"
                @promotionSelected="selectPromotion"
                @promotionUnselected="unselectPromotion"
                @input="promoIsSelected = $event"
                :otherPromoIsSelected="false"
        />

        <div
                 class="dropdown is-right active"
                v-bind:class="{'is-active': isActive}"
                v-if="promotions.length && specialPromotions.length"
        >
            <h4 @click="toggleVisibility"  class="dropdown-title">
                AKCJE
                <br/>SPECJALNE
            </h4>
            <div>
        <span    @click="toggleVisibility"  class="dropdown-trigger dropdown-trigger-top-bar" aria-controls="dropdown-menu2">
          <i class="arrow down"></i>
        </span>
            </div>
            <div class="dropdown-menu" id="dropdown-menu2" role="menu">
                <div class="dropdown-content top-bar-color">
                    <div class="dropdown-item">
                        <promo-btn
                                v-for="promotion in specialPromotions"
                                :key="promotion.id"
                                :promotionData="promotion"
                                :isDropdown="true"
                                @promotionSelected="selectPromotion"
                                @promotionUnselected="unselectPromotion"
                                @input="promoIsSelected = $event"
                                :otherPromoIsSelected="false"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PromoBtn from "./promo-btn";
    import EventBus from "../eventBus";

    export default {
        name: "promo-list",
        data() {
            return {
                promoIsSelected: false,
                filterIcon: true,
                isActive: false,
                promotionSelectedId: null,
                iconUp: false
            };
        },
        components: {
            PromoBtn
        },
        computed: {
            promotions() {
                return this.$store.getters.promotions;
            },
            specialPromotions() {
                return this.promotions
                    .filter(promotion => promotion.visible_on_places_list && promotion.visible_menu)
            }
        },
        mounted() {
            this.filterIcon = this.$siteAssetDir + "/../tools-and-utensils.png";
            let that = this;
            EventBus.$on("MAP_READY", payload => {
                that.selectPromotion(payload.promotionSelected);
                that.unselectPromotion(payload.promotionUnselect);

                that.promoIsSelected = true;
                that.promotionSelectedId = payload.promotionSelected.id;
            });

            EventBus.$on('CLOSE_OTHER', (payload) => {
                that.isActive = false
            })


        },

        methods: {
            selectPromotion(promotionData) {
                // Kod tylko na CNW
                if (this.$siteVariant === 2 && promotionData.id == 6) {
                    this.$store.commit("selectPromotion", [promotionData.id, 7]);
                } else {
                    this.$store.commit("selectPromotion", promotionData.id);
                }
            },
            unselectPromotion(promotionData) {
                // Kod tylko na CNW
                if (this.$siteVariant === 2 && promotionData.id == 6) {
                    this.$store.commit("removePromotion", [promotionData.id, 7]);
                } else {
                    this.$store.commit("removePromotion", promotionData.id);
                }
            },
            toggleVisibility() {
                this.isActive = !this.isActive;
                this.filterIcon = !this.filterIcon;
            },
        }
    };
</script>

<style lang="scss" scoped>
    .top-bar-color {
        background-color: #26a037;
    }

    .dropdown {
        align-items: center;
    }

    .dropdown-trigger div {
        width: 35px;
        height: 5px;
        background-color: white;
        margin: 6px 0;
    }

    .dropdown-trigger div:hover {
        cursor: pointer;
    }

    .dropdown-trigger-top-bar {
        padding: 10px;
        margin-right: 20px;
    }

    .title-dropdown {
        font-size: 16px;
    }

    .dropdown-title {
        cursor: pointer;
        text-transform: uppercase;
        font-weight: 700;
        color: white;
        font-size: 14px;
        padding: 5px;
        line-height: 15px;
        margin-top: 10px;
    }
</style>
